import { KK, VK } from '@/define/define'
import { BaseDevice, CustomLayout, DebounceTime, Dpi, initDpiColor, initDpiList, initDpiRange } from '../base_device'
import icon from '@/assets/img/device/amber/icon.png'
import board from '@/assets/img/device/amber/board.png'
import { mouseVKCodes } from '../keyboard/keycode/vkeycode'
import { DeviceType } from '@libs/types/enum'

export class Amber358 extends BaseDevice {
  name: string = 'Amber_35_8'
  icon: string = icon
  boardImage: string = board
  width: number = 214
  paddingX: number = 0
  paddingY: number = 0
  paddingBottom: number = 0
  texture = {}
  deviceType = DeviceType.mouse
  resetDes = ''
  inoperableKeys: KK[] = [0x0]
  lightEffectList: { [name: string]: number } = {}

  vkcodes = mouseVKCodes
  absoluteKey: CustomLayout = {
    0x01: this.createSquare(108, 0, 98, 210),
    0x02: this.createSquare(93, 38, 33, 66),
    0x04: this.createSquare(1, 128, 13, 59),
    0x03: this.createSquare(3, 190, 15, 59),
  }
  mouseClass: { [index: KK]: string } = {
    0x01: 'right',
    0x02: 'middle',
    0x04: 'forward',
    0x03: 'back',
  }
  speedAllowValues = [1, 2, 3, 4, 5]
  lightAllowValues = [1, 2, 3, 4]
  dpi: Dpi = {
    initList: initDpiList(),
    initListColor: initDpiColor(),
    length: 6,
    list: initDpiRange(),
    des: 'he2_dpi_des',
    isEdit: false,
    isColor: false,
  }
  rate: number[] = [0.125, 0.25, 0.5, 1, 2, 4, 8]

  // 睡眠 （默 认 值 60s, 取 值 范 围）
  // (10,20,30,60,120,180,240,300,360,420,480,540, 600,660,720,780,840,900.
  sleepTimeValues = [10, 20, 30, 60, 120, 180, 240, 300, 360, 420, 480, 540, 600, 660, 720, 780, 840, 900]
  debounceTime: DebounceTime = {
    max: 30,
    initValue: 8,
  }
}
